import { render, staticRenderFns } from "./Outlets.vue?vue&type=template&id=b6f39ad2&scoped=true&"
import script from "./Outlets.vue?vue&type=script&lang=js&"
export * from "./Outlets.vue?vue&type=script&lang=js&"
import style0 from "./Outlets.vue?vue&type=style&index=0&id=b6f39ad2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f39ad2",
  null
  
)

export default component.exports